import "react-calendar/dist/Calendar.css";
import { ChakraProvider } from "@chakra-ui/react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { theme } from "./config/theme";
import { WebRoutes } from "./routes";
import "./App.css";

function App() {
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY || ""
  );

  return (
    <ChakraProvider theme={theme}>
      <Elements
        stripe={stripePromise}
        options={
          { appearance: { theme: "stripe" } }
          //   {
          //   clientSecret:
          //     process.env.REACT_APP_STRIPE_SECRET_KEY,
          // }
        }
      >
        <WebRoutes />
      </Elements>
    </ChakraProvider>
  );
}

export default App;
